import { FC } from 'react';
import styles from './ReviewCardSkeleton.module.scss';
import Box from '@/components/UI/box/Box';
import Skeleton from '@/components/UI/skeleton/Skeleton';
type Props = {
  isBrief?: boolean;
};
const ReviewCardSkeleton: FC<Props> = ({
  isBrief = true
}) => {
  return <Box className={styles['review-card-skeleton']} data-sentry-element="Box" data-sentry-component="ReviewCardSkeleton" data-sentry-source-file="ReviewCardSkeleton.tsx">
      <Box className={styles['user-information-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReviewCardSkeleton.tsx">
        <Skeleton variant="circular" width={36} height={36} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
        <Box className={styles['user-review-info']} data-sentry-element="Box" data-sentry-source-file="ReviewCardSkeleton.tsx">
          <Skeleton variant="text" width={100} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
          <Skeleton variant="text" width={40} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
        </Box>
        <Box className={styles['review-details-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReviewCardSkeleton.tsx">
          <Skeleton variant="text" width={30} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
          <Skeleton variant="text" width={30} height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
        </Box>
      </Box>
      {!isBrief && <Box className={styles['positive-negative-container']}>
          <Box className={styles['positive-negative-items']}>
            <Skeleton variant="text" width={12} height={12} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
          <Box className={styles['positive-negative-items']}>
            <Skeleton variant="text" width={12} height={12} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
          <Box className={styles['positive-negative-items']}>
            <Skeleton variant="text" width={12} height={12} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
        </Box>}
      <Skeleton variant="text" width="100%" height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
      <Skeleton variant="text" width="100%" height={20} data-sentry-element="Skeleton" data-sentry-source-file="ReviewCardSkeleton.tsx" />
    </Box>;
};
export default ReviewCardSkeleton;